export const QUOTE_UPLOAD_LIMITS = {
  guest: {
    maxFiles: 8,
    maxFileBytes: 8 * 1024 * 1024,
    maxTotalBytes: 25 * 1024 * 1024,
  },
  registered: {
    maxFiles: 10,
    maxFileBytes: 10 * 1024 * 1024,
    maxTotalBytes: Number.POSITIVE_INFINITY,
  },
} as const;

export type QuoteUploadValidation = {
  valid: boolean;
  message?: string;
};

export function validateQuoteUploadSelection(
  files: readonly Pick<File, "size">[],
  guestMode: boolean,
  existingFiles: readonly Pick<File, "size">[] = [],
): QuoteUploadValidation {
  const limits = guestMode ? QUOTE_UPLOAD_LIMITS.guest : QUOTE_UPLOAD_LIMITS.registered;
  const totalFiles = existingFiles.length + files.length;
  if (totalFiles > limits.maxFiles) {
    return {
      valid: false,
      message: guestMode
        ? "Guest quotes allow up to 8 files."
        : "You can upload up to 10 files.",
    };
  }

  const oversized = files.find((file) => file.size > limits.maxFileBytes);
  if (oversized) {
    return {
      valid: false,
      message: guestMode
        ? "Each guest upload must be 8 MB or smaller."
        : "Each upload must be 10 MB or smaller.",
    };
  }

  if (Number.isFinite(limits.maxTotalBytes)) {
    const totalBytes = [...existingFiles, ...files].reduce((sum, file) => sum + file.size, 0);
    if (totalBytes > limits.maxTotalBytes) {
      return {
        valid: false,
        message: "Guest uploads are limited to 25 MB total.",
      };
    }
  }

  return { valid: true };
}